var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPhone(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "m9.243 3 1.121 4.469.005.023a2.88 2.88 0 0 1-.15 1.613l-.381 1.047c.527.82 1.128 1.586 1.846 2.3a14.022 14.022 0 0 0 2.246 1.82l1.157-.504a2.74 2.74 0 0 1 1.7-.213l.022.004 4.191.957L20.33 21l-.941-.048c-4.278-.219-8.308-1.969-11.35-5l-.004-.003a17.26 17.26 0 0 1-4.98-11.125L3 3.916 9.243 3ZM5.118 5.608a15.273 15.273 0 0 0 4.325 8.944 15.246 15.246 0 0 0 9.11 4.345l.293-2.84-2.433-.556a.744.744 0 0 0-.465.053l-.023.01-2.148.937-.438-.262a15.918 15.918 0 0 1-3.056-2.384 15.784 15.784 0 0 1-2.393-3.079l-.245-.405.72-1.972.006-.015a.91.91 0 0 0 .055-.484L7.754 5.22l-2.636.387Z",
    fill: "#333"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhone);
export default __webpack_public_path__ + "static/media/phone.87bbc82ff777da8fe51cb4854a91dd9d.svg";
export { ForwardRef as ReactComponent };